import LocationEdit from './locationEdit'
export default LocationEdit
